import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const screen = (theme: Theme) => css`
  ${breakpoint.down('xs')} {
    background: ${theme.palette.background.accent};
  }
`

export const content = (theme: Theme) => css`
  border-radius: ${theme.borderRadius.xl};
  padding: ${size[24]};
  width: auto;

  ${breakpoint.down('xs')} {
    background: ${theme.palette.background.main};
    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  ${breakpoint.up('sm')} {
    margin: 0 ${size[16]} ${size[8]};
  }
`
